export enum PbxCallState {
	/** Call is starting */
	CALL_START = 'CALL_START',
	/** Call is ringing */
	CALL_RING = 'CALL_RING',
	/** Call is answered */
	CALL_ANSWER = 'CALL_ANSWER',
	/** Call is being held / is on hold */
	CALL_HOLD = 'CALL_HOLD',
	/** Call is being unheld */
	CALL_UNHOLD = 'CALL_UNHOLD',
	/** Call has ended */
	CALL_END = 'CALL_END',
	/** Call details updated */
	CALL_UPDATE = 'CALL_UPDATE'
}
